import {request} from '@/plugins/axios'
import qs from 'qs';
//调高德地址模糊搜索
export async function addressSearchFromGaode(opt) {
    return await request({
        url: '/api/com/search_detail',
        method: 'get',
        params:opt 
    })
}
// 客服信息
export async function getCustomer(opt) {
    return await request({
        url: '/api/u_h/customer',
        method: 'get',
        params:opt 
    })
}